import { render, staticRenderFns } from "./RPM.vue?vue&type=template&id=45fa58b4&"
import script from "./RPM.vue?vue&type=script&lang=js&"
export * from "./RPM.vue?vue&type=script&lang=js&"
import style0 from "./RPM.vue?vue&type=style&index=0&id=45fa58b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports